module.exports = __webpack_public_path__ + "31e397ed4e5aabeb21f5cf2cf93dfe7e.png";